// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"aa3ca6c1","77":"3d5ac341","115":"ba25f6ef","133":"61c239af","222":"9dd358f6","280":"07560e9f","320":"d21ab5f2","354":"8b535586","444":"31bd161e","526":"48e8e32d","567":"f561161f","612":"79dd2d93","716":"15847cca","814":"90bbbdf6","836":"d8b5e2a7","860":"58480e63"}[chunkId] + ".chunk.js";
};